import { Card } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useFlags } from "launchdarkly-react-client-sdk";

import { PackageDetails } from "../../../../../../components/package-details/PackageDetails";
import { Package } from "../../../PackageContext";
import { getTotalAddOnsCost } from "../../../../../../pages/order/order-utils";
import { calculatePackageReviewPrice } from "../../../package-utils";

interface PackageReviewPreviewProps {
  packageData: Package;
  currency: "USD" | "EUR" | "GBP" | "AUD" | "CAD" | "NZD";
}

export function PackageReviewPreview({
  packageData,
  currency,
}: PackageReviewPreviewProps) {
  const { packageImprovements } = useFlags();

  const packagePrice = packageImprovements
    ? calculatePackageReviewPrice(packageData, currency)
    : (() => {
        const checkPrices = packageData.checks.map((check) => check.cost);
        const bundlePrices = packageData.bundles.map((bundle) => bundle.total);
        const allPrices = [...checkPrices, ...bundlePrices];
        const addOnCost = getTotalAddOnsCost(packageData.checks);
        return {
          price: Number(
            (allPrices.reduce((a, b) => a + b, 0) + addOnCost).toFixed(2)
          ),
          currency,
        };
      })();

  const selectedCheckList = packageData.checks.map((check) => ({
    ...check.checkDetails,
    selectedOptions: check.selectedOptions,
    check_arguments: check.check_arguments,
  }));
  const bundleChecks = packageData.bundles.flatMap(
    (bundle) => bundle.checks?.map((check) => check) || []
  );
  const packageChecks = [...selectedCheckList, ...bundleChecks];
  return (
    <Card className={styles.packageCard}>
      <PackageDetails
        name={packageData.name}
        description={packageData.description}
        price={packagePrice}
        tags={packageData.tag_names}
        checks={packageChecks}
        isAtsPackage={Boolean(packageData.is_ats_package)}
        isApiPackage={Boolean(packageData.is_api_package)}
        clientInputClaims={packageData.client_input_claims}
        useExactPriceLabel={packageImprovements}
      />
    </Card>
  );
}

const styles = {
  packageCard: css({
    padding: "var(--space-4)",
  }),
};
